import axiosIns from '@/libs/axios'

const ROOT_URL = '/Admin/core/file_upload'
export default {
  namespaced: true,
  state: {
    uploadFile: {
      id: null,
      file_name: null,
      file_type: null,
      file_size: null,
      unique_hash: null,
      title: null,
      notes: null,
      is_secret: null,
      id_document_groups: null,
      id_projects: null,
      id_users: null,
    },
    dataSave: {
      message: null,
      status: null,
      id: null,
    },
    uploading: false,
  },
  getters: {
    dataSaveStatus(state) {
      return state.dataSave
    },
    uploading(state) {
      return state.uploading
    },
  },
  mutations: {
    SET_DATA_SAVE(state, data) {
      state.dataSave = data
    },
    SET_UPLOAD_FILE(state, data) {
      state.uploadFile = data
    },
    SET_UPLOADING(state, data) {
      state.uploading = data
    },
  },
  actions: {
    uploadProjectFile({ commit }, postData) {
      commit('SET_UPLOADING', true)
      const formData = new FormData()
      formData.append('title', postData.title)
      formData.append('notes', postData.notes)
      formData.append('is_secret', postData.is_secret)
      formData.append('id_document_groups', postData.id_document_groups)
      formData.append('id_projects', postData.id_projects)
      formData.append('upload_file', postData.upload_file)
      return axiosIns
        .post(`${ROOT_URL}/projectFiles`, formData, { headers: { 'Content-Type': 'multipart/form-data' } })
        .then(response => {
          commit('SET_UPLOAD_FILE', response.data.data)
          commit('SET_UPLOADING', false)
          return response.data
        })
        .catch(error => console.error(error))
    },
    removeData({ commit }, params) {
      return axiosIns
        .post(`${ROOT_URL}/deleteData`, { id, type: params.type })
        .then(response => {
          commit('SET_DATA_SAVE', response.data)
          return response.data
        })
        .catch(error => console.error(error))
    },
  },
}
